export default __webpack_public_path__ + "static/media/41.1e529407.png";